import { wfetch } from "../utils/fetch";
import { debounce } from "../utils/performance";
import { createElement, removeChildren, highlightSubstring } from "../utils/DOMutils";
import animateValue, { updateHeight } from "../utils/animateValue";
import { getSearchInputElements, handleSearchInput, handleSearchReset } from "../utils/searchInput";

export default function(el) {
    const resultsEl = el.querySelector(".ho__results");
    const [searchInput, inputEl, resetButtonEl] = getSearchInputElements(el);
    const restUrl = el.dataset.restUrl;
    let abortController = null;

    const state = {
        searchQuery: null,
        results: [],
    };

    const createResultEl = (name, link) => {
        const highlightedName = highlightSubstring(name, state.searchQuery, "ho__result-highlight");
        const listItemEl = createElement("li", { class: "ho__result" });
        const linkEl = createElement("a", { class: "ho__result-link", href: link });

        linkEl.innerHTML = highlightedName;

        listItemEl.appendChild(linkEl);

        return listItemEl;
    };

    const appendResults = () => {
        const resultsListEl = createElement("ul", { class: "ho__results-list" });

        for (const result of state.results) {
            if (!result.name || !result.link) continue;

            const listItemEl = createResultEl(result.name, result.link);

            resultsListEl.appendChild(listItemEl);
        }

        resultsEl.appendChild(resultsListEl);
    };

    const animateResultsElHeight = (actionType = "add") =>
        animateValue(
            resultsEl,
            updateHeight,
            resultsEl.offsetHeight,
            actionType === "remove" ? 0 : resultsEl.scrollHeight,
            300
        );

    const handleInput = debounce((e) => {
        state.searchQuery = e.target.value;

        abortController && abortController.abort();

        abortController = new AbortController();

        if (state.searchQuery.length < 3) return resetState();

        wfetch(`${restUrl}?inputQuery=${state.searchQuery}`, { signal: abortController.signal })
            .then((result) => {
                resetState();

                if (!Array.isArray(result.data) || result.data.length === 0) return;

                state.results = result.data;
                appendResults();
                animateResultsElHeight();
            })
            .catch((err) => {});
    }, 300);

    const resetState = () => {
        if (state.results.length === 0) return;

        state.results = [];
        removeChildren(resultsEl);
        animateResultsElHeight("remove");
    };

    if (!inputEl || !resultsEl || !restUrl) return;

    inputEl.addEventListener("input", handleInput);

    if (resetButtonEl) {
        if (searchInput)
            inputEl.addEventListener(
                "input",
                handleSearchInput.bind(null, searchInput, "search-input--filled")
            );

        resetButtonEl.addEventListener("click", handleSearchReset.bind(null, inputEl));
    }
}
